import { createFileRoute } from '@tanstack/react-router';

/** The blank new conversation; the layout route renders the page. */
export const Route = createFileRoute('/_app/admin/agent/_chat/')({});
